import React, { memo } from 'react';
import classNames from 'classnames';
import { Typography } from '../../../foundations/typography';
import styles from './PromotionDescription.module.scss';
/**
 * @tdr
 */
var PromotionDescription = memo(function (_a) {
    var _b;
    var price = _a.price, promotion = _a.promotion, color = _a.color;
    var promotionDescription = promotion.promotionDescription, promotionSubText = promotion.promotionSubText, promotionTypeCode = promotion.promotionTypeCode;
    return (React.createElement(Typography, { className: classNames(styles.offerDescription, (_b = {},
            _b[styles.green] = color === 'green',
            _b)), styleAs: "paragraphHeading", noMargins: true, "data-testid": "promo-description" },
        promotionTypeCode !== 'NLP' ? promotionDescription : "Was ".concat(price),
        promotionSubText && (React.createElement(Typography, { styleAs: "paragraphHeading", element: "em", "data-testid": "promo-description-em" }, promotionSubText))));
});
PromotionDescription.displayName = 'ProductPodImage';
export default PromotionDescription;
//# sourceMappingURL=PromotionDescription.js.map